import { ReactNode } from 'react';
import { TriangleAlert } from 'lucide-react';

/** The amber notice used on the tax-exempt page. */
const Notice = ({ children }: { children: ReactNode }) => (
  <div
    role="note"
    className="flex items-start gap-2 rounded-md border border-[#FFD8A8] bg-[#FFF7E8] px-3 py-2 text-xs text-[#8A4B08]"
  >
    <TriangleAlert className="mt-px h-3.5 w-3.5 shrink-0" />
    <div>{children}</div>
  </div>
);

export default Notice;
